<p-message
    [dt]="pMessageScopedToken"
    severity="info"
    variant="text"
    class="text-center"
    styleClass="w-full text-center !rounded-none !py-0">
    <ng-template #container>
        <div
            class="relative flex min-h-8 w-full items-center justify-center px-11 text-sm font-medium leading-normal">
            <div>
                <span aria-hidden="true">🌼 </span>You’re a
                <span class="font-semibold">Group Sessions Host!</span>
                <span aria-hidden="true"> · </span>
                <button
                    type="button"
                    class="cursor-pointer underline underline-offset-2 hover:no-underline"
                    (click)="onClickLearnMore()">
                    Learn more
                </button>
            </div>

            <button
                type="button"
                aria-label="Dismiss Group Sessions host announcement"
                class="absolute right-2 top-1/2 flex size-8 -translate-y-1/2 items-center justify-center rounded-lg transition-opacity hover:opacity-70"
                (click)="onClickDismiss()">
                <i class="pi pi-times text-sm leading-none"></i>
            </button>
        </div>
    </ng-template>
</p-message>
